module.exports = __webpack_public_path__ + "media/images/countrysquared/lt-f7c2687b536f0e9a96efb77eb191292a.svg";